export default "__VITE_ASSET__CL9Y5bU4__"